/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { clone as r } from "../core/lang.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import { writer as t } from "../core/accessorSupport/decorators/writer.js";
import { collectArcadeFieldNames as o } from "../layers/support/fieldUtils.js";
import l from "./Renderer.js";
import { VisualVariablesMixin as a } from "./mixins/VisualVariablesMixin.js";
import { DictionaryLoader as n } from "./support/DictionaryLoader.js";
var p;
let c = p = class extends a(l) {
  constructor(e) {
    super(e), this.config = null, this.fieldMap = null, this.scaleExpression = null, this.scaleExpressionTitle = null, this.url = null, this.type = "dictionary";
  }
  get _loader() {
    return new n(this.url, this.config, this.fieldMap);
  }
  writeData(e, r) {
    e && (r.scalingExpressionInfo = {
      expression: e,
      returnType: "number"
    });
  }
  writeVisualVariables(e, r, s, i) {
    i?.origin || super.writeVisualVariables(e, r, s, i);
  }
  clone() {
    return new p({
      config: r(this.config),
      scaleExpression: this.scaleExpression,
      scaleExpressionTitle: this.scaleExpressionTitle,
      fieldMap: r(this.fieldMap),
      url: r(this.url),
      visualVariables: r(this.visualVariables)
    });
  }
  async getSymbolAsync(e, r) {
    return this._loader.getSymbolAsync(e, r);
  }
  async collectRequiredFields(e, r) {
    await this.collectVVRequiredFields(e, r), this.scaleExpression && (await o(e, r, this.scaleExpression));
    for (const s in this.fieldMap) {
      const i = this.fieldMap[s];
      r.has(i) && e.add(i);
    }
  }
  get arcadeRequired() {
    return !0;
  }
  getSymbol() {
    return null;
  }
  getSymbols() {
    return [];
  }
  getAttributeHash() {
    return this.visualVariables && this.visualVariables.reduce((e, r) => e + r.getAttributeHash(), "");
  }
  getMeshHash() {
    return `${this.url}-${JSON.stringify(this.fieldMap)}`;
  }
  getSymbolFields() {
    return this._loader.getSymbolFields();
  }
};
e([s({
  type: n
})], c.prototype, "_loader", null), e([s({
  type: Object,
  json: {
    read: {
      source: "configuration"
    },
    write: {
      target: "configuration"
    }
  }
})], c.prototype, "config", void 0), e([s({
  type: Object,
  json: {
    write: !0
  }
})], c.prototype, "fieldMap", void 0), e([s({
  type: String,
  json: {
    read: {
      source: "scalingExpressionInfo.expression"
    },
    write: !0
  }
})], c.prototype, "scaleExpression", void 0), e([t("scaleExpression")], c.prototype, "writeData", null), e([s({
  type: String,
  json: {
    read: {
      source: "scalingExpressionInfo.title"
    },
    write: {
      target: "scalingExpressionInfo.title",
      overridePolicy(e) {
        return {
          enabled: !!e && !!this.scaleExpression
        };
      }
    }
  }
})], c.prototype, "scaleExpressionTitle", void 0), e([s({
  type: String,
  json: {
    write: !0
  }
})], c.prototype, "url", void 0), e([t("visualVariables")], c.prototype, "writeVisualVariables", null), c = p = e([i("esri.renderers.DictionaryRenderer")], c);
const u = c;
export { u as default };